/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';

import {AmexIcon, DiscoverIcon, LockIcon, MastercardIcon, VisaIcon} from '@salesforce/retail-react-app/app/components/icons';
import Link from '@salesforce/retail-react-app/app/components/link';
import {Button, Flex} from '@salesforce/retail-react-app/app/components/shared/ui';

const CartCta = () => {
  return (
    <Fragment>
      <Button
        as={Link}
        marginTop={[6, 6, 2, 2]}
        mb={4}
        rightIcon={<LockIcon />}
        to="/checkout"
        variant="solid"
        width={['95%', '95%', '95%', '100%']}
      >
        <FormattedMessage
          defaultMessage="Proceed to Checkout"
          id="cart_cta.link.checkout"
        />
      </Button>
      <Flex justify="center">
        <VisaIcon height={8} mr={2} width={10} />
        <MastercardIcon height={8} mr={2} width={10} />
        <AmexIcon height={8} mr={2} width={10} />
        <DiscoverIcon height={8} mr={2} width={10} />
      </Flex>
    </Fragment>
  );
};

export default CartCta;
